export default "__VITE_ASSET__BrbczH2n__"